import {
  FormControl,
  MenuItem,
  TextField,
  TextareaAutosize,
  Select as SelectComponent,
  Box,
} from "@mui/material";
import React, { useEffect, useState, useRef, Fragment } from "react";
// import { fetchIndustryData } from '../../../actions/orgActions';
import { businessunitTypesService } from "../../../services/orgService";
import "./BusinessUnitCreation.scss";
import { PhoneInput } from "react-international-phone";
import Select, { components } from "react-select";
import { bulkUploadService } from "../../../services/emissionService";
import TimezoneSelect, { allTimezones } from "react-timezone-select";
import { toastMessage, fileTypeMatch } from "../../../helper";
import { useNavigate } from "react-router-dom";
import { fetchBusinessUsers } from "../../../services/userService";
import { errorMessage } from "../../../constants/messageConstants";
import MapsInput from "../../common/MapsInput";
import { green, neutral } from "../../../constants/colorConstants";
import moment from "moment-timezone";
import DropdownIndicator from "../../DropDownIndicator/DropDownIndicator";
import { Select as AntSelect, Cascader } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  EMAIL_REGEX,
  PHONE_NUMBER_INDIA_REGEX,
  PHONE_NUMBER_SINGAPORE_REGEX,
} from "../../../constants/regexConstants";
import {
  BUSINESS_UNIT_TARGET_TYPE,
  DIAL_CODE,
  STEPS,
} from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import { industriesService } from "../../../services/orgService";

function filter(inputValue: string, path: any) {
  return path.some(
    (option: any) =>
      option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
}

const styles = (theme: any) => ({
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #D7DFE9",
    borderRadius: "8px",
    height: "3rem",
  },
  "&:hover": {
    ".MuiOutlinedInput-notchedOutline": {
      border: "2px solid #59CE90 !important",
    },
  },
});

const customStyles = {
  dropdownIndicator: (base: any) => ({
    ...base,
    color: neutral[500],
    padding: "6px !important",
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: "none",
  }),
  control: (base: any, state: any) => ({
    ...base,
    boxShadow: "none",
    borderColor: "none",
    borderRadius: "8px",
    border: "1px solid #D7DFE9",
    height: "2.5rem",
    "&:hover": {
      border: "2px solid #59CE90 !important",
    },
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: "none",
    color: neutral[900],
    "&:hover": {
      backgroundColor: state.isFocused ? green[100] : "",
    },
  }),
  menu: (base: any, state: any) => ({
    ...base,
    boxShadow:
      "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
    overflow: "hidden ",
    marginTop: "4px",
    borderRadius: "8px",
  }),
};
const BusinessUnitCreation = (props: any) => {
  const { t, i18n } = useTranslation();
  const {
    setStep,
    countryOptions,
    formData,
    setFormData,
    industries,
    setIndustries,
  } = props;
  let isEdit = !!props?.id;
  const [errorData, setErrorData] = useState({
    emailError: "",
    mobileError: "",
    registrationIdError: "",
    unitNameError: "",
    industryTypeError: "",
  });
  const navigate = useNavigate();
  const [businessUnitTypes, setBusinessUnitTypes] = useState([] as any[]);

  const {
    incharge,
    name,
    email,
    type,
    phone,
    registrationId,
    facilityBoundary,
    address,
    country,
    timeZone,
    parentIndustryName,
    childIndustryName,
  } = formData;
  const { emailError, registrationIdError, mobileError, unitNameError } =
    errorData;
  const [industryTypeValue, setIndustryTypeValue] = useState([] as any[]);
  const [incharges, setIncharges] = useState([] as any[]);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [imageURL, setImageURL] = useState("");
  const [additionalTimeZones, setAddtionalTimeZones] = useState({
    "America/Adak": "America",
  });
  const [industryId, setIndustryId] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const { Option } = AntSelect;

  if (
    isEdit &&
    parentIndustryName &&
    childIndustryName &&
    industryTypeValue.length === 0
  ) {
    setIndustryTypeValue([parentIndustryName, childIndustryName]);
  }

  const getTimezone = (timezones: string[]) => {
    if (timezones.length === 0) {
      return "";
    }
    let tempTimezone: any = {};
    timezones.map((zone: any) => {
      const words = zone.split("/");
      tempTimezone[`${zone}`] = words[1];
    });
    setAddtionalTimeZones(tempTimezone);
    return timezones[0];
  };
  const onChange = (e: any, target: string) => {
    //validateFields(e.target.name,e.target.value);
    if (target === BUSINESS_UNIT_TARGET_TYPE.NAME) {
      setFormData({
        ...formData,
        name: e.target.value,
      });
    }
    if (target === BUSINESS_UNIT_TARGET_TYPE.INCHARGE) {
      const reqIncharge = incharges.filter((each: any) => each.id === e)[0];
      setFormData({
        ...formData,
        incharge: reqIncharge?.id,
        inchargeName: reqIncharge?.email,
      });
    } else if (target === BUSINESS_UNIT_TARGET_TYPE.TYPE) {
      const bunitType = businessUnitTypes.find((type) => type.id === e);
      setFormData({
        ...formData,
        type: bunitType.id,
        typeName: bunitType.name,
      });
    } else if (target === BUSINESS_UNIT_TARGET_TYPE.INDUSTRY_TYPE) {
      const existingSelections = industryTypeValue || [];
      const newSelection = [e[0], e[1]];

      // Merge new selections with existing ones
      const mergedSelections = Array.from(
        new Set([...existingSelections, ...newSelection])
      );

      setIndustryTypeValue(mergedSelections);
      const industryType: any = industries.filter((eachIndustry: any) => {
        if (eachIndustry.value === e[0]) {
          return eachIndustry;
        }
      })[0];
      const reqIndustryId: any = industryType.children.filter(
        (eachChildren: any) => eachChildren.value === e[1]
      )[0];
      setIndustryId(String(reqIndustryId?.id));
      setIndustryTypeValue([e[0], e[1]]);
      setFormData({
        ...formData,
        industry: reqIndustryId.id,
        parentIndustryName: e[0],
        childIndustryName: e[1],
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    if (
      target !== BUSINESS_UNIT_TARGET_TYPE.INDUSTRY_TYPE &&
      target !== BUSINESS_UNIT_TARGET_TYPE.FACILITY_BOUNDARY
    ) {
      validateFields(e.target.name, e.target.value);
    }
  };
  const onChangeTimeZone = (e: any) => {
    console.log("timezone value", e.value);
    setFormData({
      ...formData,
      timeZone: e.value,
      address: { ...formData.address, timeZone: e.value },
    });
  };
  const onChangePhone = (e: string) => {
    if (e) {
      let phone: any = e.split(" ");
      let dialCode = phone[0];
      let mobile = "";
      phone.forEach((each: any, index: number) => {
        if (index > 0) {
          mobile = mobile + each + " ";
        }
      });
      setFormData({
        ...formData,
        phone: e,
        mobile: mobile,
        dialCode: dialCode,
      });
    }
    validateFields("phone", e);
  };
  const onChangeAddress = (e: any) => {
    const addressForm: any = address;
    var key = e.target.name;
    //addressForm[key] = value;
    if (key === "address") {
      const newForm = { ...formData };
      newForm.address.addressLine1 = e.target.value.addressLine;
      newForm.address.stateCode = e.target.value.stateCode;
      newForm.address.countryCode = e.target.value.countryCode;
      newForm.address.city = e.target.value.city;
      newForm.address.cityCode = e.target.value.cityCode || "";
      newForm.address.state = e.target.value.state;
      newForm.address.country = e.target.value.country;
      newForm.timeZone = getTimezone(
        moment.tz.zonesForCountry(e.target.value.countryCode)
      );
      newForm.address.timeZone = getTimezone(
        moment.tz.zonesForCountry(e.target.value.countryCode)
      );
      newForm.country = e.target.value.country
        ? countryOptions.find(
            (o: any) => o.value === e.target.value.countryCode
          )
        : { value: "IN", label: "India" };
      setFormData(newForm);
    } else {
      setFormData({ ...formData, address: addressForm });
    }
    console.log("formData ", formData);
  };
  const onChangeCountry = (e: any) => {
    console.log("value", e);
    setFormData({
      ...formData,
      country: e,
      address: { ...formData.address, country: e.value, countryCode: e.value },
    });
  };
  const fetchBunitTypes = async () => {
    const res = await businessunitTypesService();
    setBusinessUnitTypes(res.data);
    setFormData((prevState: any) => {
      return {
        ...prevState,
        type: res.data[0]?.id,
        typeName: res?.data[0]?.name,
      };
    });
  };

  const fetchIncharges = () => {
    return fetchBusinessUsers({})
      .then((res) => {
        const data = res?.data;
        setIncharges(data);
        setFormData((prevState: any) => {
          return {
            ...prevState,
            incharge: data[0]?.id,
            inchargeName: data[0]?.displayName
              ? data[0]?.displayName
              : data[0]?.email,
          };
        });
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  };
  useEffect(() => {
    (async () => {
      await fetchIncharges();
      await fetchBunitTypes();
      await fetchIndustryData();
    })();
  }, []);

  const [company, setCompany] = useState(
    JSON.parse(localStorage.getItem("company") || "{}")
  );

  const isValidForm = () => {
    return (
      name &&
      !unitNameError &&
      type &&
      !emailError &&
      incharge &&
      registrationId &&
      !registrationIdError &&
      !mobileError &&
      parentIndustryName &&
      childIndustryName &&
      address &&
      address?.addressLine1
    );
  };
  const validateFields = (name: string, value: string) => {
    let substrings = ["gmail", "yahoo"];
    if (name === "name") {
      setErrorData({ ...errorData, unitNameError: "" });
      if (value.length < 3 || value.length > 50) {
        setErrorData({
          ...errorData,
          unitNameError: errorMessage().BUSINESS_UNIT_NAME_ERROR,
        });
      }
    } else if (name === "email") {
      setErrorData({ ...errorData, emailError: "" });
      //regex mail
      if (!EMAIL_REGEX.test(value)) {
        //setErrorData((prevState)=>{return {...prevState,emailError: "Invalid Email"}});
        setErrorData({ ...errorData, emailError: "* Invalid Email" });
      } else if (
        substrings.some((v) => value.includes(v)) &&
        company.accountType == "CORPORATE"
      ) {
        setErrorData({
          ...errorData,
          emailError: "Use Only Company Emails For Registration",
        });
      }
    } else if (name === "registrationId") {
      setErrorData({ ...errorData, registrationIdError: "" });
      //regex mail
      if (
        value.length < 3 ||
        value.length > 50 ||
        !value.match("^[a-zA-Z0-9]*$")
      ) {
        setErrorData({
          ...errorData,
          registrationIdError: errorMessage().REGISTRATION_FORMAT,
        });
        //setErrorData((prevState)=>{return {...prevState,codeError: "Registration Id Should be 3 - 20 digit Alphanumeric"}});
      }
    } else if (name === "parentIndustryName" || name === "childIndustryName") {
      if (!value) {
        setErrorData({
          ...errorData,
          industryTypeError: errorMessage().INDUSTRY_TYPE_ERROR,
        });
      }
    } else {
      setErrorData({ ...errorData, mobileError: "" });
      let phone: any = value.split(" ");
      let dialcode = phone[0];
      if (
        dialcode === DIAL_CODE.INDIA &&
        !PHONE_NUMBER_INDIA_REGEX.test(value)
      ) {
        setErrorData({
          ...errorData,
          mobileError: "Enter valid phone number",
        });
      } else if (
        dialcode === DIAL_CODE.SINGAPORE &&
        !PHONE_NUMBER_SINGAPORE_REGEX.test(value)
      ) {
        setErrorData({
          ...errorData,
          mobileError: "Enter valid phone number",
        });
      } else {
        if (value.length < 10 || value.length > 15)
          setErrorData({
            ...errorData,
            mobileError: "Enter valid phone number",
          });
      }
    }
  };
  // useEffect(()=>{fetchEmployees()},[]);
  const handleChange = (event: any) => {
    if (
      event.target.files.length > 0 &&
      fileTypeMatch("image/*", event.target.files[0].type, "Invalid file type")
    ) {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      bulkUploadService(formData).then((res) => {
        setIsFileUploaded(true);
        setImageURL(res.data.Location);
        setFormData((prevState: any) => {
          return {
            ...prevState,
            imageUrl: res.data.Location,
          };
        });
      });
    }
  };

  const fetchIndustryData = async () => {
    const indusRes = await industriesService();
    const updatedData: any = [];
    indusRes.data.map((each: any) => {
      const childrenData: any = [];
      each.children.map((eachchildren: any) => {
        childrenData.push({
          value: eachchildren.name,
          label: eachchildren.name,
          id: eachchildren.id,
        });
      });
      const currData = {
        value: each.code,
        label: each.code,
        children: [...childrenData],
      };
      updatedData.push(currData);
    });
    setIndustries([...updatedData]);
  };

  const handleClick = () => {
    setIsFileUploaded(false);
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };
  return (
    <Fragment>
      <div className="pw-bunit-main w-55v overflow-y-auto">
        <div className="pw-input-label pw-create-label">
          {isEdit ? t("Edit") : t("Add")}&nbsp; {t("Facility")}
        </div>
        <div className="pw-bunit-create-desc pw-border-bottom pb-2">
          {t("Please provide necessary information below for this Facility")}
        </div>
        <div className="pw-bunit-main-details flex flex-row">
          <div className="pw-left-div  flex flex-col w-68">
            <div className="">
              <div className="flex flex-row pw-form-field">
                <div className="pw-input-label pw-text">{t("Name")}</div>
                <div className="pw-mandatory-icon">*</div>
              </div>
              <TextField
                type="text"
                variant="outlined"
                placeholder={t("Name")}
                size="small"
                name="name"
                value={name}
                onChange={(e) => onChange(e, "name")}
                className="pw-width-100 pw-input-field pw-input-text"
                sx={styles}
              />
              {unitNameError ? (
                <div className="pw-display-error">* {unitNameError}</div>
              ) : (
                ""
              )}
            </div>
            <div className="">
              <div className="flex flex-row pw-form-field">
                <div className="pw-input-label pw-text">
                  {t("Account Owner")}
                </div>
                <div className="pw-mandatory-icon">*</div>
              </div>

              <FormControl fullWidth size="small" className="pw-form-select">
                <AntSelect
                  suffixIcon={
                    <CaretDownOutlined className="!pointer-events-none" />
                  }
                  value={incharge}
                  disabled={true}
                  className="pw-creation-select pw-account-owner-select"
                  onChange={(e) => onChange(e, "incharge")}
                >
                  {incharges.map((eachIncharge: any, index) => (
                    <MenuItem key={eachIncharge.id} value={eachIncharge.id}>
                      {eachIncharge.displayName
                        ? eachIncharge.displayName
                        : eachIncharge.email?.split("@")[0]}
                    </MenuItem>
                  ))}
                </AntSelect>
              </FormControl>
            </div>

            <div className="">
              <div className="flex flex-row pw-form-field">
                <div className="pw-input-label pw-text">{t("Facility")}</div>
                <div className="pw-mandatory-icon">*</div>
              </div>
              <Box>
                <FormControl fullWidth size="small" className="pw-form-select">
                  <AntSelect
                    suffixIcon={
                      <CaretDownOutlined className="!pointer-events-none" />
                    }
                    value={type}
                    className="pw-creation-select pw-facility-select"
                    onChange={(e) => onChange(e, "type")}
                  >
                    {businessUnitTypes?.map(({ name, id }, index: number) => (
                      <Option key={id} value={id} className="pw-menu-item">
                        {name}
                      </Option>
                    ))}
                  </AntSelect>
                </FormControl>
              </Box>
            </div>
            <div className="">
              <div className="flex flex-row pw-form-field">
                <div className="pw-input-label pw-text">Industry type</div>
                <div className="pw-mandatory-icon">*</div>
              </div>
              <Cascader
                suffixIcon={
                  <CaretDownOutlined className="!pointer-events-none" />
                }
                className="pw-creation-select pw-facility-select pw-e2e-industrytype"
                placeholder="Select Industry Type"
                style={{ width: "36rem" }}
                value={industryTypeValue}
                options={industries}
                onChange={(e) => onChange(e, "industryType")}
                showSearch={{ filter }}
              />
            </div>
          </div>
          <div className="pw-right-div flex flex-col justify-center">
            <input
              type="file"
              accept="image/*"
              hidden
              ref={inputRef}
              onChange={handleChange}
            />

            <div>
              <img
                src={
                  formData.imageUrl
                    ? formData.imageUrl
                    : "assets/images/camera.png"
                }
                alt=" "
                onClick={handleClick}
                className="pw-circ-image h-35v"
              />
            </div>
          </div>
        </div>

        <div className="">
          <div className="flex flex-row pw-form-field">
            <div className="pw-input-label pw-text">{t("address")}</div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          {/* <TextareaAutosize
                // type='text'
                // variant="outlined"
                // rows={3}
                placeholder=' Address'
                // size="small"
                name='addressLine1'
                value={address.addressLine1}
                onChange={onChangeAddress}
                className='pw-width-100 pw-input-field pw-address'
            /> */}

          <MapsInput
            defaultValue={address}
            value={address?.addressLine1}
            onChange={onChangeAddress}
            isTextArea
            setFormData={setFormData}
            formData={formData}
          />
        </div>
        <div className="pw-multi-fields w-5/6 flex flex-row justify-between">
          <div className=" pw-small-field">
            <div className="flex flex-row pw-form-field">
              <div className="pw-input-label pw-text">{t("Country")}</div>
              <div className="pw-mandatory-icon">*</div>
            </div>
            <Select
              options={countryOptions}
              className="pw-country-select"
              value={country}
              onChange={(e) => onChangeCountry(e)}
              styles={customStyles}
              components={{ DropdownIndicator }}
            />
          </div>
          <div className=" pw-big-field">
            <div className="pw-input-label pw-text">{t("Time Zone")}</div>
            <TimezoneSelect
              value={timeZone}
              timezones={{
                ...allTimezones,
                ...additionalTimeZones,
              }}
              name="timeZone"
              onChange={(e) => onChangeTimeZone(e)}
              styles={customStyles}
              className="pw-timezone-select"
              components={{ DropdownIndicator }}
            />
          </div>
        </div>
        <div className="">
          <div className="flex flex-row pw-form-field">
            <div className="pw-input-label pw-text">
              {t("Facility Registration ID")}
            </div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          <TextField
            type="text"
            variant="outlined"
            placeholder={t("Facility Registration ID")}
            size="small"
            name="registrationId"
            value={registrationId}
            disabled={isEdit}
            onChange={(e) => onChange(e, "registrationId")}
            className="w-4/5 pw-input-field pw-input-text"
            sx={styles}
          />
          {registrationIdError ? (
            <div className="pw-display-error">* {registrationIdError}</div>
          ) : (
            ""
          )}
        </div>

        <div>
          <div className="flex flex-row pw-form-field">
            <div className="pw-input-label pw-text">
              {t("Facility Boundary")}
            </div>
          </div>
          <TextareaAutosize
            placeholder={t("Enter Facility Boundaries")}
            name="facilityBoundary"
            value={facilityBoundary}
            onChange={(e) =>
              onChange(e, BUSINESS_UNIT_TARGET_TYPE.FACILITY_BOUNDARY)
            }
            className="pw-width-100  pw-address pw-input-text"
          />
        </div>

        <div className="pw-multi-fields w-5/6 flex flex-row justify-between">
          <div className=" pw-small-field">
            <div className="flex flex-row pw-form-field">
              <div className="pw-input-label pw-text">{t("Contact")}</div>
            </div>
            <PhoneInput
              initialCountry="in"
              value={phone}
              onChange={(e) => onChangePhone(e)}
              className="pw-bunit-phone-input pw-phonecode-select"
            />
            {mobileError ? (
              <span className="pw-display-error">{mobileError}</span>
            ) : (
              ""
            )}
          </div>
          <div className=" pw-big-field">
            <div className="pw-input-label pw-text">{t("email")} </div>
            <TextField
              type="text"
              variant="outlined"
              placeholder={t("email")}
              size="small"
              value={email}
              name="email"
              onChange={(e) => onChange(e, "email")}
              className="pw-width-100 pw-input-field pw-input-text"
              sx={styles}
            />
            {emailError ? (
              <span className="pw-display-error">{emailError}</span>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* <div className='pw-parent-link flex flex-row justify-between items-center'>
            <div className='pw-text'>Link Business Unit   </div>
            <div className='flex flex-row items-center'><input type="radio" name='businessunitselection' className='pw-radiobutton' /> <div>Parent to</div></div>
            <div className='flex flex-row items-center'><input type="radio" name='businessunitselection' className='pw-radiobutton' /> <div>Child to </div></div>
            <select
                name="parent"
                value={parent}
                className="pw-bunit-select"
                onChange={e => onChange(e)}
                >
                {businessunits?.map(({ name, id }, index) => 
                <option key={id} value={id} >{name}</option>)}
            </select>    
        </div> */}
        {/* <div className='pw-parent-link flex flex-row justify-between items-center'>
            <div>Link Business Unit   </div>
            <div>Child to </div>
            <select
                name="parent"
                value={parent}
                className="pw-bunit-select"
                onChange={e => onChange(e)}
                >
                {businessunits?.map(({ name, id }, index) => 
                <option key={id} value={id} >{name}</option>)}
            </select>    
        </div> */}
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={() => navigate("/organisation/facility")}
        >
          {t("Cancel")}
        </div>
        <button
          className={`pw-bunit-button-primary pw-bunit-button-next pw-e2e-next-button text-white  font-bold ${
            isValidForm()
              ? "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          }`}
          onClick={() => {
            isValidForm() && setStep(STEPS.ADD_PREFERENCE);
          }}
          disabled={!isValidForm()}
        >
          {t("Next")}
        </button>
      </div>
    </Fragment>
  );
};

export default BusinessUnitCreation;
